module.exports = __webpack_public_path__ + "static/media/slider_5_collab_user_es.7570d27a.svg";